import { render, staticRenderFns } from "./PhoneViewer.vue?vue&type=template&id=2ca6cd58&scoped=true&"
import script from "./PhoneViewer.vue?vue&type=script&lang=js&"
export * from "./PhoneViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca6cd58",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSlideXReverseTransition,VSlideXTransition})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca6cd58')) {
      api.createRecord('2ca6cd58', component.options)
    } else {
      api.reload('2ca6cd58', component.options)
    }
    module.hot.accept("./PhoneViewer.vue?vue&type=template&id=2ca6cd58&scoped=true&", function () {
      api.rerender('2ca6cd58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/phone/components/PhoneViewer.vue"
export default component.exports